import {createAsyncThunk} from "@reduxjs/toolkit"
import {AppThunkProps} from "store"
import {api} from "utils/http"
import {ReportResponse} from "types/Report"

type ReturnedType = {
    status: "success"
    data: ReportResponse
}

export const fetchReportByApplicationId = createAsyncThunk<ReturnedType, number, AppThunkProps>(
    "fetch/report/application-id",
    async (applicationId, {signal}) => {
        return api.get<ReturnedType>(`/applications/${applicationId}/reports`, {signal})
    }
)
